import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    shareholderList: [],
    totalCount: 0,
    pagination: PAGINATION
  },
  mutations: {
    setShareholderList(state, payload) {
      state.shareholderList = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setShareholderTotal(state, payload) {
      state.totalCount = payload;
    }
  },
  getters: {},
  actions: {
    list({ commit }, query) {
      commit('setPagination', { page: query.page, size: query.size });

      api.listShareholders(query).then(({ data }) => {
        commit('setShareholderList', data.list);
        commit('setShareholderTotal', data.totalCount);
      });
    },
    check(context, data) {
      return api.shareholderCheck({ date: data });
    },
    calculate(context, data) {
      return api.calculateTeamAmount({ date: data });
    }
  }
};

appStore.registerModule('dividendShareholder', store);
